import { Button, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import ImageUpload from '../../ImageUpload/ImageUpload';

const EditProfilePictureScreen = ({profile, onCompleted}) => {

    const [modifiedProfile, setModifiedProfile] = useState(profile);
    const [completed, setCompleted] = useState(false);
    const stage = 1; 

    useEffect(()=>{

        console.log('passed profile: ', profile);

        setModifiedProfile(profile);

    }, []);

    const onSelectedFile = (file, avColors) => {

        console.log('modifiedProfile: ', modifiedProfile, ' file: ', file);

        if(file){

            console.log('updating state!');
            setModifiedProfile(prev => {

                console.log('about to return updated state');
            
                return {
                    ...prev, 
                    selectedFile: file
                }
            });
    
            setCompleted(true);
        }else {
            setCompleted(false);
        }
        

    }

    const submitImage = () => {

        if(typeof onCompleted == 'function'){

            onCompleted(modifiedProfile, stage);
        }
    }


    return (
        
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>

            <Typography className='edit-title'> 

                Add Profile Picture
            </Typography>
 
            <form style={{marginTop: '40px'}}>

                <ImageUpload 
                    sx={{width: '100%', height: '100%'}} 
                    previewSx={{borderRadius: '100%'}} 
                    forcedAspect={{x:1, y:1}} 
                    text='Choose Image' 
                    onSelected={onSelectedFile}
                    forceCrop={true}
                    />

            </form>

            {
                completed &&
                <Button variant='main' sx={{marginTop: '30px'}} onClick={submitImage}>
                   Next
                </Button>
            }
            

        </Box>
    );
}

export default EditProfilePictureScreen; 